import React from 'react';
import './TransactionProgressIndicator.css';

/**
 * Modern progress indicator component for async transaction processing
 * Shows only current state with clean, minimal design
 */
function TransactionProgressIndicator({ progress, loading }) {
  // Don't show if no progress or completed
  if (!progress || progress.status === 'COMPLETED' || (!loading && !progress)) {
    return null;
  }

  const currentStep = progress.currentStep || 'Processing your transactions...';
  const progressPercentage = progress.progressPercentage || 0;

  // Format the current step text to be more user-friendly
  const formatStepText = (step) => {
    if (!step) return 'Processing...';
    // Capitalize first letter and ensure it ends with proper punctuation
    const formatted = step.charAt(0).toUpperCase() + step.slice(1);
    return formatted.endsWith('.') ? formatted : formatted + '...';
  };

  return (
    <div className="transaction-progress-container">
      <div className="transaction-progress-card">
        {progress.status === 'PROCESSING' && (
          <div className="progress-details">
            {/* Subtle Title */}
            <div className="progress-card-title">
              Loading Your Tax Insights
            </div>

            {/* Current Step Text */}
            <div className="progress-step-text">
              {formatStepText(currentStep)}
            </div>

            {/* Modern Animated Progress Bar */}
            <div className="progress-bar-wrapper">
              <div className="progress-bar-container">
                <div 
                  className="progress-bar-fill"
                  style={{ width: `${progressPercentage}%` }}
                >
                  <div className="progress-bar-shimmer"></div>
                </div>
              </div>
              <div className="progress-percentage">
                {progressPercentage}%
              </div>
            </div>
          </div>
        )}
        
        {progress.status === 'FAILED' && (
          <div className="progress-error">
            <p className="error-message">
              {progress.errorMessage || 'An error occurred while processing transactions'}
            </p>
          </div>
        )}

        {progress.status === 'PENDING' && (
          <div className="progress-pending">
            <p>Preparing to process transactions...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TransactionProgressIndicator;

